import { Controller } from "@hotwired/stimulus"
import React from "react"
import ReactDOM from "react-dom/client"
import WidgetExample from "../components/widget-example"

export default class extends Controller {

  connect() {
    this.root = ReactDOM.createRoot(this.element)
    this.root.render(
      <WidgetExample/>
    )
  }

  disconnect() {
     this.root.unmount()
  }
  
}
